module.exports = __webpack_public_path__ + "img/schnittkante_enzianblau_ral5010.56a78f98.jpg";